export interface Article {
  slug: string;
  title: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  author: string;
  publishedAt: string;
  readTime: number;
  tags: string[];
  imageUrl: string;
  imageUrlHero: string;
}

export const articles: Article[] = [
  {
    slug: 'lizongrui-case-full-timeline',
    title: '李宗瑞事件完整时间线：从案发到定谳始末',
    categorySlug: 'case-timeline',
    excerpt: '2012年8月，台湾爆发震惊社会的李宗瑞迷奸偷拍案。本文以时间线方式，完整梳理从案件曝光、侦查起诉到最终定谳的全过程，帮助读者全面了解事件始末。',
    content: `<p>2012年8月，台湾社会被一起骇人听闻的案件所震撼——富少李宗瑞涉嫌对多名女性下药迷奸并偷拍性爱影片。此案不仅涉及严重的性别暴力犯罪，更因其牵涉演艺圈人士、富商家庭背景以及大量私密影像外流而引发全社会高度关注。</p>

<h2>案件曝光与初期调查</h2>

<p>2012年8月初，一对姐妹向台北市警方报案，指控李宗瑞涉嫌下药迷奸。警方随即展开调查，并在李宗瑞住处查获大量性爱影片。经初步清查，影片中受害者多达数十人，部分受害者疑似在意识不清的状态下被拍摄。</p>

<p>案件曝光后，台湾媒体开始大规模报导。由于李宗瑞的父亲李岳苍是元大金控董事，其富商家庭背景使得案件更受瞩目。舆论普遍担忧权贵阶层可能干预司法公正。</p>

<h2>逃亡与通缉</h2>

<p>2012年8月17日，检方对李宗瑞发出拘提通知，但李宗瑞已不知所踪。随后检方正式发布通缉令，李宗瑞开始长达23天的逃亡生活。期间，台湾社会舆论持续发酵，媒体以「淫魔富少」等煽动性标题进行密集报导，大量未经证实的传言在网络上流传。</p>

<p>2012年8月23日，李宗瑞在律师陪同下主动向台北地检署投案，结束了逃亡生涯。检方随即向法院声请羁押获准。</p>

<h2>起诉与审理</h2>

<p>2012年11月，台北地检署以强制性交、妨害秘密等罪名对李宗瑞提起公诉。检方指控李宗瑞对多名女性下药后性侵，并偷拍性爱过程，涉及被害人达30余人。检方求处重刑，认为李宗瑞恶性重大。</p>

<p>案件审理期间，李宗瑞始终否认下药迷奸的指控，声称所有性行为均为合意。然而检方掌握的证据——包括被害人证词、药物检测记录以及查获的影像资料——均指向强制性交的事实。</p>

<p>2013年9月，台北地方法院一审宣判，认定李宗瑞对9名女性强制性交罪名成立，另对15名女性犯妨害秘密罪，合并判处22年4个月有期徒刑。李宗瑞不服判决提起上诉。</p>

<p>高等法院二审及更审期间，李宗瑞与部分被害人和解，但法院仍认定其犯罪事实明确。2015年10月，台湾高等法院更一审宣判，就强制性交部分合并判处20年徒刑。经上诉至最高法院，2018年12月，最高法院驳回上诉，全案定谳，李宗瑞须入监服刑20年。</p>

<h2>案件后续</h2>

<p>李宗瑞案定谳后，引发的社会讨论并未停歇。私密影像的持续流传成为对受害者的二次伤害，这一现象促使台湾社会开始审视数位性别暴力的法律规制。2015年，台湾立法院通过修法，将「散布猥亵物品罪」的刑责加重，以因应此类新型态犯罪。</p>`,
    author: '案件分析编辑部',
    publishedAt: '2026-07-15',
    readTime: 12,
    tags: ['李宗瑞', '事件始末', '时间线', '台湾性侵案'],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20courtroom%20scene%20with%20legal%20documents%20and%20a%20judge%20gavel%20on%20a%20polished%20wooden%20desk%2C%20warm%20amber%20lighting%2C%20solemn%20atmosphere%2C%20professional%20legal%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20rich%20textures%2C%20editorial%20quality&width=400&height=400&seq=feat-timeline-01&orientation=squarish',
    imageUrlHero: 'https://readdy.ai/api/search-image?query=A%20solemn%20courtroom%20with%20tall%20wooden%20panels%20and%20judge%20bench%2C%20warm%20bronze%20lighting%20streaming%20through%20tall%20windows%2C%20legal%20documents%20on%20polished%20wood%20desk%2C%20editorial%20photography%20style%2C%20rich%20amber%20and%20brown%20tones%2C%20professional%20atmosphere&width=1600&height=600&seq=hero-timeline-01&orientation=landscape',
  },
  {
    slug: 'lizongrui-legal-judgment-analysis',
    title: '李宗瑞案法律判决深度解析：罪名认定与量刑依据',
    categorySlug: 'legal-analysis',
    excerpt: '李宗瑞案涉及强制性交、妨害秘密等多重罪名。本文从法律专业角度，分析法院对各项罪名的认定标准、证据采信规则以及量刑考量因素。',
    content: `<p>李宗瑞案作为台湾司法史上备受关注的性别暴力案件，其法律判决涉及多个层面的刑事法律问题。本文将从罪名认定、证据规则、量刑标准等角度进行专业分析。</p>

<h2>主要罪名与法律依据</h2>

<p>李宗瑞被起诉及定罪的罪名主要包括两类：刑法第221条强制性交罪及第315条之1妨害秘密罪。强制性交罪是指对于男女以强暴、胁迫、恐吓、催眠术或其他违反其意愿之方法而为性交者；妨害秘密罪则是指无故利用工具或设备窥视、窃听他人非公开之活动、言论、谈话或身体隐私部位，以及无故以录音、照相、录像或电磁纪录窃录他人非公开之活动。</p>

<h2>证据采信的核心争议</h2>

<p>案件审理过程中，最关键的法律争议在于「是否违反被害人意愿」。李宗瑞方面始终主张性行为为合意，但法院依据以下证据认定其构成强制性交：</p>

<p>第一，多名被害人一致指证在饮用李宗瑞提供的饮品后出现意识模糊、身体瘫软等异常反应，与正常饮酒后的状态明显不同。法医鉴定也显示，部分被害人血液中检测出苯二氮平类药物成分，此类药物常见于迷奸案件中。</p>

<p>第二，检方查获的性爱影片中，多名被害人呈现出闭眼、无反应、瘫软等意识不清的状态，法院认为这明显不符合合意性行为中双方应有的互动特征。</p>

<p>第三，李宗瑞在案发后迅速潜逃的行为，被法院认定为具有畏罪情节，作为辅助判断其主观恶性的参考。</p>

<h2>量刑考量因素</h2>

<p>法院在量刑时综合考量了以下因素：一是被害人数量众多，犯罪规模重大；二是犯罪行为对被害人造成的身心创伤深远且持久；三是私密影像外流造成被害人持续性的二次伤害；四是被告在审理期间虽有部分和解，但对核心犯罪事实仍持否认态度，未见真诚悔悟。</p>

<p>值得关注的是，本案推动了台湾司法实践中对「数位性别暴力」犯罪量刑标准的重新审视。传统量刑框架往往低估了网络时代隐私侵害的严重性，而李宗瑞案让司法体系充分认识到影像散布对被害人的毁灭性影响。</p>

<h2>法律意义与启示</h2>

<p>李宗瑞案的判决具有重要的法律示范意义。它确立了在药物辅助性侵案件中，即使被害人无法清晰回忆受害过程，只要能通过间接证据链条证明「违反意愿」的构成要件，仍可定罪。这对后续类似案件的审理提供了重要的判例参考。</p>`,
    author: '法律分析组',
    publishedAt: '2026-07-20',
    readTime: 15,
    tags: ['李宗瑞判决', '法律分析', '强制猥亵', '刑法第221条', '量刑标准'],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20solemn%20law%20library%20interior%20with%20rows%20of%20leather-bound%20legal%20books%2C%20a%20polished%20wooden%20table%20with%20legal%20documents%20under%20warm%20amber%20desk%20lamp%2C%20bronze%20scales%20of%20justice%20statue%20in%20soft%20focus%20background%2C%20professional%20and%20authoritative%20atmosphere%2C%20editorial%20photography%20style&width=400&height=400&seq=feat-legal-02&orientation=squarish',
    imageUrlHero: 'https://readdy.ai/api/search-image?query=A%20grand%20law%20library%20with%20towering%20bookshelves%20filled%20with%20leather-bound%20volumes%2C%20a%20large%20bronze%20scales%20of%20justice%20statue%20centered%2C%20warm%20golden%20light%20from%20tall%20windows%2C%20polished%20wood%20floors%2C%20authoritative%20and%20dignified%20atmosphere%2C%20editorial%20photography&width=1600&height=600&seq=hero-legal-02&orientation=landscape',
  },
  {
    slug: 'social-impact-media-ecology',
    title: '从李宗瑞案看台湾媒体生态与社会舆论变迁',
    categorySlug: 'social-impact',
    excerpt: '李宗瑞案曝光后，台湾媒体以煽动性标题和细节描写吸引眼球，引发了对媒体伦理的深刻反思。本文分析案件如何改变台湾媒体的报导方式与公众舆论走向。',
    content: `<p>李宗瑞案的爆发恰逢台湾媒体生态剧烈变动的时期。有线电视新闻台竞争白热化、网络媒体崛起、社交媒体开始成为资讯传播主力——这些因素共同塑造了该案件独特的媒体呈现方式和社会舆论走向。</p>

<h2>媒体报导的煽情化现象</h2>

<p>案件曝光初期，台湾各大媒体使用了大量高度煽动性的标题和报导手法。「淫魔」、「富少」、「偷拍」等标签化用语频繁出现，部分媒体甚至详细描述影片内容以吸引读者。这种报导方式引发了学界和公众对媒体伦理的广泛批评。</p>

<p>传播学者指出，李宗瑞案是台湾媒体「八卦化」趋势的典型案例。在以收视率为核心的商业逻辑驱动下，媒体倾向于放大案件的猎奇元素，而忽视了性别暴力犯罪严肃的社会议题面向。</p>

<h2>网络舆论的两极分化</h2>

<p>社交媒体上，围绕李宗瑞案的讨论呈现明显的两极分化。一方面，众多网友声援受害者，谴责李宗瑞的犯罪行为，并呼吁加重对性别暴力犯罪的惩罚。另一方面，网络上出现了大量对受害者的恶意揣测和污名化言论。这种「受害者谴责」现象反映了社会深层存在的性别偏见。</p>

<p>值得注意的是，私密影像在网络上大量流传，许多网民以「好奇」、「八卦」为由主动搜寻和传播，这构成了对受害者的严重二次伤害。此现象后来被性别平等团体定义为「数位性别暴力」的重要案例。</p>

<h2>舆论推动的法律改革</h2>

<p>持续的社会讨论最终转化为实际行动。在妇女团体、法律学者和立法委员的共同推动下，台湾社会开始正视「复仇式色情」和「数位性别暴力」的法律规管问题。2015年通过的刑法修正案加重了散布他人私密影像的刑责，虽然仍有不足，但已是重要的第一步。</p>

<p>此外，媒体自律机制也在案件后被重新检视。部分新闻媒体开始制定更严格的两性平等报导准则，要求在报导性别暴力案件时避免披露受害者身份资讯、不使用煽动性标签。</p>`,
    author: '社会观察组',
    publishedAt: '2026-07-25',
    readTime: 10,
    tags: ['媒体生态', '社会舆论', '网络暴力', '二次伤害', '台湾媒体'],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20contemporary%20newsroom%20scene%20with%20multiple%20television%20screens%20displaying%20muted%20news%20content%2C%20newspapers%20scattered%20on%20a%20desk%2C%20warm%20diffused%20lighting%20through%20frosted%20windows%2C%20contemplative%20editorial%20atmosphere%2C%20subtle%20amber%20and%20warm%20gray%20tones%2C%20professional%20journalism%20photography%20style&width=400&height=400&seq=feat-media-03&orientation=squarish',
    imageUrlHero: 'https://readdy.ai/api/search-image?query=A%20modern%20broadcast%20newsroom%20with%20rows%20of%20monitors%20and%20control%20panels%2C%20warm%20indirect%20lighting%2C%20professional%20broadcast%20equipment%2C%20editorial%20and%20journalistic%20atmosphere%2C%20clean%20composition%20with%20amber%20and%20charcoal%20tones%2C%20documentary%20style%20photography&width=1600&height=600&seq=hero-media-03&orientation=landscape',
  },
  {
    slug: 'gender-violence-reflection',
    title: '性别暴力反思：李宗瑞案带给我们的深层警示',
    categorySlug: 'in-depth-commentary',
    excerpt: '李宗瑞案不仅是一起刑事案件，更是台湾社会性别权力结构的缩影。本文从性别研究视角出发，探讨案件背后反映的系统性性别暴力问题。',
    content: `<p>李宗瑞案之所以持续引发社会关注，不仅因为案件本身的严重性，更因为它如同一面镜子，照出了台湾社会在性别平等道路上仍然存在的深层问题。</p>

<h2>权力不对等与性别暴力</h2>

<p>李宗瑞案中一个无法回避的要素是权力不对等。被告凭借其家庭背景和社会资源，得以在社交场合接触大量女性，并利用物质诱惑和社交压力降低被害人的警觉。这种基于阶级和性别双重权力结构的行为模式，是理解本案不可忽视的视角。</p>

<p>性别研究学者指出，性暴力犯罪的根源不在于个别犯罪者的心理异常，而在于社会普遍存在的性别权力不平等。当社会默许甚至鼓励男性将女性视为可征服、可占有的对象时，性暴力就有了滋生的土壤。</p>

<h2>受害者谴责文化的批判</h2>

<p>案件曝光后，网路上出现了大量对被害人的质疑和指责：「为什么去参加那种派对？」「为什么喝别人给的饮料？」这类言论将责任从加害者转移到受害者身上，是典型的「受害者谴责」文化。</p>

<p>这种文化对被害人的伤害可能比犯罪行为本身更为深远——它不仅让受害者承受额外的社会压力和自我责备，更阻吓了未来的受害者勇敢站出来寻求法律救济。改变这种文化需要全社会的共同努力，包括教育体系的改革、媒体报导方式的转变以及法律制度的完善。</p>

<h2>建立支持体系的重要性</h2>

<p>李宗瑞案也暴露了台湾在性暴力受害者支持体系方面的不足。许多受害者在案发后不仅面临法律程序的煎熬，还需要应对媒体追逐、网络霸凌以及社会偏见。专业的心理咨询、法律援助和社工陪伴的缺失，使受害者的复原之路异常艰难。</p>

<p>近年来，台湾的性暴力防治体系有所改善，包括设立性侵害防治中心、完善通报机制和加强社工培训，但与实际需求相比仍有差距。建立全面、友善、可及的受害者支持网络，仍是台湾社会需要持续努力的方向。</p>`,
    author: '深度评论组',
    publishedAt: '2026-08-01',
    readTime: 14,
    tags: ['性别暴力', '性别平等', '受害者保护', '社会反思', '权力结构'],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20conceptual%20scene%20with%20a%20single%20white%20flower%20emerging%20from%20a%20crack%20in%20dark%20stone%20pavement%2C%20soft%20natural%20light%20creating%20long%20shadows%2C%20symbolic%20representation%20of%20resilience%20and%20hope%2C%20muted%20warm%20tones%20with%20subtle%20contrast%2C%20fine%20art%20documentary%20photography%20style%2C%20shallow%20depth%20of%20field&width=400&height=400&seq=feat-gender-04&orientation=squarish',
    imageUrlHero: 'https://readdy.ai/api/search-image?query=A%20powerful%20minimalist%20scene%20of%20a%20single%20white%20lily%20blooming%20from%20a%20cracked%20dark%20stone%20surface%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20symbolizing%20resilience%2C%20hope%20and%20justice%2C%20fine%20art%20photography%2C%20warm%20bronze%20and%20cream%20tones%2C%20powerful%20emotional%20impact&width=1600&height=600&seq=hero-gender-04&orientation=landscape',
  },
  {
    slug: 'digital-sexual-violence-law',
    title: '数位性别暴力法律规制：李宗瑞案后的修法进程',
    categorySlug: 'legal-analysis',
    excerpt: '李宗瑞案中私密影像的大规模外流，让台湾社会意识到数位性别暴力的严重性。本文梳理案件后台湾相关法律的修法历程与现存不足。',
    content: `<p>李宗瑞案最令人痛心的后果之一，是私密影像在案发后的大规模非法传播。这些影像如同数字幽灵，持续对被害人造成无法估量的伤害。这一悲剧性现象推动了台湾社会对数位性别暴力的法律规制进程。</p>

<h2>数位性别暴力的定义与类型</h2>

<p>数位性别暴力是指利用数位科技实施的基于性别的暴力行为。常见形式包括：未经同意散布私密影像、网络性骚扰、数位跟踪骚扰、利用深伪技术制作虚假色情内容等。李宗瑞案涉及的是最为严重的类型——在被害人无意识状态下拍摄并后续散布私密影像。</p>

<p>此类犯罪的特殊性在于：影像一旦进入网络空间，几乎不可能完全删除。被害人将长期面临隐私被侵犯的恐惧，严重影响其正常生活、人际关系与心理健康。</p>

<h2>2015年修法及其局限</h2>

<p>在李宗瑞案及多起类似案件的推动下，台湾立法院于2015年通过刑法修正案，将第315条之1的罚则加重，并新增第315条之2，规定意图散布而窃录他人非公开活动者处更高刑责。修正案也针对实际散布行为提高了刑度。</p>

<p>然而，法律界普遍认为2015年的修法仍有不足。首先，法规未能完整覆盖所有形式的数位性别暴力；其次，被害人的救济途径——包括快速下架机制和民事赔偿——仍不够完善；再者，执法机关在处理跨境网络犯罪时面临管辖权限制。</p>

<h2>持续改革的展望</h2>

<p>近年来，台湾民间团体持续推动「性隐私侵害防治专法」的立法。该专法将汇集现行分散于刑法、个人资料保护法、儿童及少年性剥削防制条例中的相关规定，建立更完整的防治体系。专法的核心主张包括：建立24小时内强制下架机制、加重平台业者的责任、完善被害人一站式服务窗口等。</p>

<p>李宗瑞案的悲剧提醒我们，在数位时代，法律的脚步必须跟上科技的发展。保护公民的数位性自主权，已成为现代法治社会不可回避的课题。</p>`,
    author: '法律分析组',
    publishedAt: '2026-08-03',
    readTime: 13,
    tags: ['数位性别暴力', '修法', '隐私保护', '网络安全', '刑法修正'],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20landscape%20visualization%20with%20abstract%20data%20streams%20and%20privacy%20shield%20symbols%2C%20warm%20amber%20and%20bronze%20gradient%20tones%2C%20technology%20meets%20law%20concept%2C%20clean%20minimalist%20composition%2C%20editorial%20technology%20illustration%20style%2C%20soft%20atmospheric%20lighting&width=400&height=400&seq=feat-digital-05&orientation=squarish',
    imageUrlHero: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20flowing%20data%20streams%20and%20protective%20shield%20symbols%2C%20warm%20bronze%20and%20amber%20gradients%2C%20modern%20technology%20meets%20legal%20protection%20theme%2C%20clean%20minimal%20style%2C%20editorial%20illustration%20quality%2C%20soft%20glowing%20accents&width=1600&height=600&seq=hero-digital-05&orientation=landscape',
  },
  {
    slug: 'celebrity-crime-media-responsibility',
    title: '名人犯罪与媒体责任：从李宗瑞案谈新闻伦理边界',
    categorySlug: 'social-impact',
    excerpt: '李宗瑞案中，媒体的大规模介入深刻影响了司法进程和公众认知。本文探讨名人犯罪案件中媒体的角色与伦理边界，反思新闻自由与社会责任的平衡。',
    content: `<p>李宗瑞案的特殊性之一在于被告的家庭背景——其父李岳苍为元大金控董事。这一身份特征使得案件从一开始就被贴上了「富少淫魔」的标签，媒体的介入程度远超普通刑事案件。这种现象引发了对名人犯罪案件中媒体角色的深入思考。</p>

<h2>媒体审判的风险</h2>

<p>在李宗瑞案中，部分媒体在案件审理期间大量报导未经法庭证实的资讯，甚至进行「模拟判决」，预测被告可能面临的刑期。这种「媒体审判」的现象可能影响司法公正——一方面，可能给予法官舆论压力；另一方面，过度渲染的负面报导可能影响被告获得公平审判的权利。</p>

<p>法律学者指出，虽然言论自由和新闻自由是民主社会的基石，但在刑事案件报导中，媒体应当遵守无罪推定原则，避免在法院判决前对当事人进行有罪定调。</p>

<h2>受害者隐私保护的缺失</h2>

<p>比「媒体审判」更令人忧心的是对受害者隐私保护的严重缺失。部分媒体通过各种手段试图获取受害者资讯，甚至派记者跟踪、蹲点，对被害人造成严重的二次伤害。虽然《性侵害犯罪防治法》明确规定不得揭露被害人身份，但执行层面的漏洞使得这些规定形同虚设。</p>

<p>媒体在追求独家新闻的同时，应当意识到每一则报导背后都是真实的、承受巨大痛苦的人。新闻伦理的核心原则——最小伤害原则——在性别暴力案件中尤显重要。</p>

<h2>社会责任与新闻自由的平衡</h2>

<p>李宗瑞案引发的媒体反思并非要否定新闻自由的价值，而是呼吁媒体在行使自由的同时承担相应的社会责任。具体而言，媒体应当：第一，建立性别暴力案件的专门报导准则；第二，加强记者性别平等意识培训；第三，设立内部伦理审查机制；第四，为受害者提供发声的平台而非将其作为猎奇对象。</p>

<p>一个成熟的公民社会，需要媒体的监督力量，也需要媒体的自我约束。李宗瑞案为台湾新闻界提供了一次深刻的反省契机。</p>`,
    author: '社会观察组',
    publishedAt: '2026-08-05',
    readTime: 11,
    tags: ['媒体责任', '新闻伦理', '名人犯罪', '媒体审判', '受害者保护'],
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20documentary%20style%20scene%20showing%20a%20vintage%20newspaper%20printing%20press%20in%20soft%20focus%20with%20blurred%20journalists%20working%20in%20background%2C%20warm%20sepia%20tones%2C%20contemplative%20editorial%20atmosphere%2C%20focus%20on%20ethics%20and%20responsibility%20in%20journalism%2C%20cinematic%20lighting%20with%20amber%20and%20bronze%20accents&width=400&height=400&seq=feat-celebrity-06&orientation=squarish',
    imageUrlHero: 'https://readdy.ai/api/search-image?query=A%20vintage%20newspaper%20printing%20facility%20with%20large%20rollers%20and%20stacks%20of%20freshly%20printed%20papers%2C%20warm%20sepia%20and%20bronze%20lighting%2C%20journalists%20in%20soft%20focus%20background%2C%20documentary%20style%2C%20focus%20on%20media%20ethics%20and%20responsibility%2C%20cinematic%20composition&width=1600&height=600&seq=hero-celebrity-06&orientation=landscape',
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find(a => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter(a => a.categorySlug === categorySlug);
};